export default "__VITE_ASSET__B4pXsDUE__"